/**
 * A base config containing properties for chart data
 */
var SparklineChartData = /** @class */ (function () {
    function SparklineChartData() {
    }
    return SparklineChartData;
}());
export { SparklineChartData };
//# sourceMappingURL=sparkline-chart-data.js.map